import React, { useEffect,useState,useRef } from "react";
import { Context,Hooks,Util,Request,Storage } from "@xt/xtbase";
const {XtContext,XtAuth} = Context;
const {useTranslation} = Hooks;
const {getUrl,Big} = Util;
import styles from "./index.module.less";
import { useStore } from '@/models';
import { observer } from 'mobx-react-lite';
import arrow from "@/assets/images/finance/arrow.png";
import eyeOpen from "@/assets/images/finance/eyeopen.png";
import eyeClose from "@/assets/images/finance/eyeclose.png";
import loginSvg from "@/assets/icon-svg/finance/login.svg";
import coin1Svg from "@/assets/icon-svg/finance/coin1.svg";
import coin2Svg from "@/assets/icon-svg/finance/coin2.svg";
import SvgIcon from "@xt/SvgIcon";
import logo0Svg from "@/assets/icon-svg/finance/logo0.svg";
import logo1Svg from "@/assets/icon-svg/finance/logo1.svg";
import logo2Svg from "@/assets/icon-svg/finance/logo2.svg";
import logo3Svg from "@/assets/icon-svg/finance/logo3.svg";
const logoSvgs = [logo0Svg,logo1Svg,logo2Svg,logo3Svg];
import headlink1Svg from "@/assets/icon-svg/finance/headlink1.svg";
import headlink2Svg from "@/assets/icon-svg/finance/headlink2.svg";
import headlink3Svg from "@/assets/icon-svg/finance/headlink3.svg";
const headlinkSvgs = [headlink1Svg,headlink2Svg,headlink3Svg];

export default observer(({category=0}) => {
  const t = useTranslation();
  const { finance,fund,app} = useStore();
  const [appState] = React.useContext(XtContext);
  const {lang, theme} = appState;

  const [hideNum, setHideNum] = useState(true);

  const [showConvert, setShowConvert] = useState(false);
  const [convert, setConvert] = useState("");

  useEffect(()=>{
    if(appState.loginStatus == 1)
    {
      finance.getAssets();
      finance.getIsNewer();
    }
    var c = Storage.get("assetConvert");
    if (!c) c = "usdt";
    setConvert(c);
  },[appState.loginStatus]);

  const {totalAssets, lastInterestAmount, totalInterestAmount, totalAssetsBtc, lastInterestAmountBtc, totalInterestAmountBtc} = finance.assets;
  const precision = fund.getCurrencyPrecision("usdt") || 8;

  const titles = ["finance.simpleEarn","finance.savings","finance.staking","finance.cloudMining"];
  const descs = ["finance.simpleEarnDesc","finance.savingsDesc","finance.stakingDesc","finance.cloudMiningDesc"];
  const totals = ["finance.totalAssetsSimpleEarn", "finance.totalAssetsSavings", "finance.totalAssetsStaking", "finance.totalAssetsCloudMining"]

  const clickConvert = (c) => {
    if (c != convert) {
      Storage.set("assetConvert", c);
      setConvert(c);
    }
    closeConvert();
  };

  const bodyClick = (e) => {
    const el = document.getElementById("headAssetConvert");
    if (el && !el.contains(e.target)) {
      closeConvert();
    }
  };

  const openConvert = (e) => {
    e.nativeEvent.stopImmediatePropagation();
    setShowConvert(true);
    document.body.removeEventListener("click", bodyClick);
    document.body.addEventListener("click", bodyClick);
  };

  const closeConvert = () => {
    setShowConvert(false);
    document.body.removeEventListener("click", bodyClick);
  };

  return (<>
    <div className={styles.financeHead}>
      <div class={styles.financeHeadDiv}>
        <SvgIcon src={coin1Svg} className={styles.coin1Img} style={{color:"var(--primary-color)"}} colorNoChange/>
        <SvgIcon src={coin2Svg} className={styles.coin2Img} style={{color:"var(--primary-color)"}} colorNoChange/>
        <SvgIcon src={coin1Svg} className={styles.coin3Img} style={{color:"var(--primary-color)"}} colorNoChange/>
        <SvgIcon src={logoSvgs[category]} className={styles.logoImg+" "+styles["logoImg"+category]} style={{color:"var(--primary-color)"}} colorNoChange/>
        <div className={styles.financeHeadText}>
          <h1>{t(titles[category])}</h1>
          <p>{t(descs[category])}</p>
        </div>
        {appState.loginStatus == 1 ? <div className={styles.financeHeadCard}>
          <div className={styles.cardTotal}>
            {t(totals[category], [convert.toUpperCase()])}
            <img className={styles.cardArrow} src={arrow} onClick={openConvert} />
            <p id="headAssetConvert" className={styles.cardConvert} style={showConvert ? {} : { display: "none" }}>
              <span
                onClick={() => {
                  clickConvert("usdt");
                }}
              >
                <img src={fund.getCurrencyIcon("usdt")} />
                USDT
              </span>
              <span
                onClick={() => {
                  clickConvert("btc");
                }}
              >
                <img src={fund.getCurrencyIcon("btc")} />
                BTC
              </span>
            </p>
          </div>
          <img
            className={styles.cardEye}
            src={hideNum ? eyeClose : eyeOpen}
            onClick={() => {
              setHideNum(!hideNum);
            }}
          />
          <p className={styles.cardTotalNum}>
            <span>{hideNum ? "****" : convert == "btc" ? totalAssetsBtc : totalAssets}</span>
            {hideNum ? (
              ""
            ) : (
              <span>
                {" "}
                ≈ {fund.assist.note}
                {fund.getCoinValue(totalAssets, "usdt")}
              </span>
            )}
          </p>
          <div className={styles.cardProfit}>
            <div>
              <p>{t("finance.profitYesterday", [convert.toUpperCase()])}</p>
              <p>{hideNum ? "****" : convert == "btc" ? lastInterestAmountBtc : lastInterestAmount}</p>
            </div>
            <div>
              <p>{t("finance.profitTotal", [convert.toUpperCase()])}</p>
              <p>{hideNum ? "****" : convert == "btc" ? totalInterestAmountBtc : totalInterestAmount}</p>
            </div>
          </div>
          <div className={styles.cardLinks}>
            <a href={getUrl("/orders/finance/myproduct")}>{t("finance.history")}</a>
            <a href={getUrl("/wallet/account/finance")}>{t("finance.account")}</a>
          </div>
        </div> : <div className={styles.financeHeadCard}>
          <SvgIcon className={styles.loginImg} src={loginSvg} style={{color:"var(--primary-color)"}}/>
          <p className={styles.loginText}>{t("finance.loginTip")}</p>
          <p className={styles.loginBtn} onClick={()=>{
            window.location.href = getUrl("/accounts/login?backurl="+encodeURIComponent(window.location.href));
          }}>{t("home.logIn")}</p>
        </div>}
      </div>
    </div>
    {!app.isH5 && category == 0 ? <div className={styles.financeHeadLinks}>
      <div className={styles.financeHeadLinkContainer}>
        {[1,2].map((item)=>{
          return <div className={styles.financeHeadLinkDiv}>
            <div onClick={()=>{
              if(item == 2)
                window.location.href = getUrl("/finance/staking");
              else
                window.location.href = getUrl("/finance/savings");
            }}>
              <SvgIcon src={headlinkSvgs[item-1]} style={{color:"var(--primary-color)"}} colorNoChange/>
              <p>{t(titles[item])}</p>
              <p>{t(descs[item])}</p>
            </div>
          </div>
        })}
      </div>
    </div> : null}
  </>);
});